import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';

import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import {
    ColumnsViewDef,
    ContextRoleService,
    GlobalsService,
    MetaService,
    SaveUserContextRoleProfileRequestDTO,
    UserContextRoleProfileStatusPermissionDTO,
} from '../../data';
import { UserContextRoleScopeProfileBase } from './user-context-role-scope-profile-base';
import { UIBlockerComponent } from '../../data/components/ui-blocker/ui-blocker.componet';
import { DataFieldComponent } from '../../data/components/data-field/data-field.component';
import { DataTableComponent } from '../../data/components/data-table/data-table.component';
import { UserContextRoleScopeProfileHeaderComponent } from './user-context-role-scope-profile-header.component';
import { SaveCancelButtonsComponent } from '../../shared/save-cancel-buttons/save-cancel-buttons.component';

@Component({
    selector: 'app-user-context-role-scope-profile-approved',
    templateUrl: './user-context-role-scope-profile-approved.component.html',
    styleUrls: ['./user-context-role-scope-profile-approved.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        ButtonModule,
        ConfirmDialogModule,
        TableModule,
        UIBlockerComponent,
        DataFieldComponent,
        DataTableComponent,
        UserContextRoleScopeProfileHeaderComponent,
        SaveCancelButtonsComponent,
    ],
    providers: [ConfirmationService, DynamicDialogRef],
})
export class UserContextRoleScopeProfileApprovedComponent extends UserContextRoleScopeProfileBase {
    columns: ColumnsViewDef = new ColumnsViewDef([
        {
            name: 'permissionCd',
            header: '',
            width: '3rem',
        },
        {
            name: 'permissionName',
            header: '',
        },
    ]);

    permissions: UserContextRoleProfileStatusPermissionDTO[] = [];
    prevPermissions?: string;
    currPermissions?: string;

    constructor(
        confirmSrv: ConfirmationService,
        dialogSrv: DialogService,
        contextRoleSrv: ContextRoleService,
        dialogRef: DynamicDialogRef,
        dialogCfg: DynamicDialogConfig,
        translateSrv: TranslateService,
        toastr: ToastrService,
        globals: GlobalsService,
        metaSrv: MetaService,
        location: Location,
    ) {
        super(confirmSrv, dialogSrv, contextRoleSrv, dialogRef, dialogCfg, translateSrv, toastr, globals, metaSrv, location);

        this._translateKey = `${this._translateKey}.approved`;
    }

    get isApproveValidated(): boolean {
        return this.prevPermissions !== this.currPermissions;
    }

    override onReadProfilePermissions(): void {
        this.permissions = this.profile.permissions ?? [];

        this.prevPermissions = this.permissionsToString();
        this.currPermissions = this.prevPermissions;
    }

    get defaultPermissionSelected(): string {
        if (this.permissions.length > 0) {
            return this.permissions[0].permissionCd ?? '';
        }

        return '';
    }

    get allowMultiplePermissions(): boolean {
        return this.profile.allowMultiplePermissions === true;
    }

    getPermissionButtonIcon(item: UserContextRoleProfileStatusPermissionDTO): string {
        if (item.isSelected === true) {
            return 'pi pi-check';
        }
        return 'pi';
    }

    getPermissionButtonClass(item: UserContextRoleProfileStatusPermissionDTO): string {
        let res = 'p-button p-button-outlined idb-action-button';

        if (this.profile.canEdit !== true) {
            res = res + ' idb-not-allowed';
        }

        return res;
    }

    onPermissionButtonClick(item: UserContextRoleProfileStatusPermissionDTO) {
        if (this.allowMultiplePermissions) {
            item.isSelected = !item.isSelected;
        } else {
            this.permissions.forEach((p) => {
                if (p !== item) {
                    p.isSelected = false;
                }
            });
            item.isSelected = true;
        }

        this.currPermissions = this.permissionsToString();
    }

    permissionsToString(): string {
        const result = this.permissions
            .filter((p) => p.isSelected === true)
            .map((p) => p.permissionCd)
            .join(',');

        return result;
    }

    onSave() {
        const permissions = this.permissionsToString();

        const request: SaveUserContextRoleProfileRequestDTO = {
            profileStatus: 'approved',
            profilePermissionsList: permissions,
        };

        this.saveProfilePermissions(request);
    }
}
